import Nullstack from 'nullstack';
export default function IconCoffin({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-coffin",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 3l-2 6l2 12h6l2 -12l-2 -6z"
  }), "   ", Nullstack.element("path", {
    d: "M10 7v5"
  }), "   ", Nullstack.element("path", {
    d: "M8 9h4"
  }), "   ", Nullstack.element("path", {
    d: "M13 21h4l2 -12l-2 -6h-4"
  }), " ");
}